export default [{
  name: 'todaystore',
  path: '/todaystore',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/todaystore/Application.vue').default
}, {
  name: 'todaystore/event',
  path: '/todaystore/event',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/todaystore/ApplicationEvent.vue').default
}, {
  name: 'todaystore/landing',
  path: '/todaystore/landing',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/todaystore/Landing.vue').default
}, {
  name: 'connect/todaystore',
  path: '/connect/todaystore',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/todaystore/Landing.vue').default
}]
